import { render, staticRenderFns } from "./CategoriesUpdate.vue?vue&type=template&id=2c5df37e&scoped=true&"
import script from "./CategoriesUpdate.vue?vue&type=script&lang=js&"
export * from "./CategoriesUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5df37e",
  null
  
)

export default component.exports